module.exports = __webpack_public_path__ + "img/bg_function02_3_t.43dd6bc2.png";